import React from 'react';

import { RecursiveMenuMaxMenu as RDCRecursiveMenuMaxMenu } from '@uncinc/react-drupal-core';
import type { RecursiveMenuMaxMenuProps } from '@uncinc/react-drupal-core/dist/Components/RecursiveMenu/types';

import withHeading, { type RecursiveMenuWithHeadingProps } from './withHeading';

const RecursiveMenuMaxMenu: React.FC<RecursiveMenuWithHeadingProps<RecursiveMenuMaxMenuProps>> = (props) => (
  <RDCRecursiveMenuMaxMenu {...props} />
);

export default withHeading<RecursiveMenuMaxMenuProps>(RecursiveMenuMaxMenu);
